// extracted by mini-css-extract-plugin
export var component = "EcpPeople-module--component--041a0";
export var fadePop = "EcpPeople-module--fade-pop--7a798";
export var growHeightIn = "EcpPeople-module--grow-height-in--19474";
export var peopleWrapper = "EcpPeople-module--peopleWrapper--084e5";
export var titleWrapper = "EcpPeople-module--titleWrapper--6204c";